import { render, staticRenderFns } from "./related.vue?vue&type=template&id=4d2330aa&scoped=true&"
import script from "./related.vue?vue&type=script&lang=js&"
export * from "./related.vue?vue&type=script&lang=js&"
import style0 from "./related.vue?vue&type=style&index=0&id=4d2330aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2330aa",
  null
  
)

export default component.exports